import { css } from "@emotion/react";

export const video = css`
  margin-top: 60px;
  object-fit: contain;
  height: 500px;
  z-index: 0;
  box-shadow: 0 8px 80px -8px rgba(0, 0, 0, 0.2),
    0px 0px 0px 0.5px rgba(0, 0, 0, 0.03);
  width: 100%;
`;

export const audio = css`
  margin-top: 100px;
  object-fit: cover;
  width: 900px;
  z-index: 0;
`;

export const buttonIcon = css`
  width: 30px;
  height: 30px;
`;

export const pictureAndButton = css`
  position: relative;
`;
